export default {
  IDENTITY_MARKETER_DOSE_NOT_EXIST: "شناسه بازاریابی موجود نیست..",
  IDENTITY_MARKETER_INVALID: "شناسه بازاریابی نامعتبر است.",
};
